// Studyo Today Backend
// Package studyo.schools.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/account_info.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schools/v1/resources/account_info.proto.
 */
export const file_studyo_today_schools_v1_resources_account_info = /*@__PURE__*/
  fileDesc("CjRzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvYWNjb3VudF9pbmZvLnByb3RvEiFzdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMiNwoLQWNjb3VudEluZm8SEQoJZnVsbF9uYW1lGAEgASgJEhUKDWVtYWlsX2FkZHJlc3MYAiABKAlCKaoCJlN0dWR5by5Ub2RheS5TY2hvb2xzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the message studyo.today.schools.v1.resources.AccountInfo.
 * Use `create(AccountInfoSchema)` to create a new message.
 */
export const AccountInfoSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_account_info, 0);

